import { inject, Injectable } from '@angular/core';
import { ApiGatewayService } from '../../core/api-gateway.service';
import { DashboardQuoteSummary } from './dashboard-data.resolver';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  gateway = inject(ApiGatewayService);

  getSummary(): Observable<DashboardQuoteSummary[]> {
    return this.gateway.get('/api/v1/dashboard');
  }
}
